var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.5003 2.1665L18.8337 5.49984M2.16699 18.8332L3.23066 14.9331C3.30006 14.6786 3.33475 14.5514 3.38802 14.4327C3.43531 14.3274 3.49343 14.2273 3.56142 14.1339C3.638 14.0288 3.73125 13.9356 3.91775 13.7491L12.5289 5.13791C12.6939 4.9729 12.7764 4.8904 12.8716 4.85949C12.9553 4.8323 13.0454 4.8323 13.1291 4.85949C13.2242 4.8904 13.3067 4.9729 13.4717 5.13791L15.8623 7.52843C16.0273 7.69344 16.1098 7.77594 16.1407 7.87108C16.1679 7.95477 16.1679 8.04491 16.1407 8.12859C16.1098 8.22373 16.0273 8.30624 15.8623 8.47124L7.25108 17.0824C7.06458 17.2689 6.97134 17.3622 6.86623 17.4387C6.7729 17.5067 6.67276 17.5649 6.56742 17.6121C6.44878 17.6654 6.32156 17.7001 6.06711 17.7695L2.16699 18.8332Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil02);
export default __webpack_public_path__ + "static/media/pencil-02.61fb03ccfcf3644f3f9fbd83a5c190db.svg";
export { ForwardRef as ReactComponent };